import { tokens } from "@manifesthhqinc/ui-library";
import styled, { keyframes } from "styled-components";
import { LabelMedium } from "../../../components/font";

const fadeInOpacity = keyframes`
	0% {
		opacity: 0;
      transform: translateY(25px);
	}
	100% {
		opacity: 1;
      transform: translateY(0px);
	}
`;

export const DraggableTileContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DraggableTile = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .mds-option-tile {
    touch-action: none;
  }
`;

export const DraggableNumber = styled.div`
  flex-basis: 28px;
  display: flex;
  justify-content: flex-start;
`;

export const IRALoadingContentList = styled.div`
  margin-top: 19px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const IRALoadingContentItem = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  justify-content: flex-start;
  border-bottom: 1px solid ${tokens.color.neutral[400]};
  padding: 21px 0;
  &:last-child {
    border-bottom: none;
  }
  transform: translateY(25px);
  opacity: 0;
  animation-name: ${fadeInOpacity};
  animation-timing-function: ease-in;
  animation-duration: 0.75s;
  animation-fill-mode: forwards;

  &.fade-in-item-1 {
    animation-delay: 0.45s;
  }
  &.fade-in-item-2 {
    animation-delay: 1.45s;
  }
  &.fade-in-item-3 {
    animation-delay: 2.45s;
  }
  &.fade-in-item-4 {
    animation-delay: 3.45s;
  }
`;

export const IRAProviderLogoDiv = styled.div<{ $isLarge?: boolean }>`
  width: 100%;

  padding: ${(props) => (props.$isLarge ? "50px 44px" : "32px 52px")};
  background: white;
  border-radius: 7px;
  border: 1px solid ${tokens.color.neutral[400]};
  margin-top: 24px;
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 100%;
    width: 100%;
    max-width: 200px;
    max-height: 40px;
    object-fit: contain;
  }
`;

export const IRAFeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  padding: 0 6px;
`;

export const IRAFeatureListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

export const Dot = styled.div`
  height: 5px;
  width: 5px;
  background: ${tokens.color.brand[500]};
`;

export const IRAOptionFeatureDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 30px;
`;

export const HenrySuggestionIRATile = styled.div<{ $isFeatured: boolean }>`
  position: relative;
  padding: 24px;
  background: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${(props) =>
    props.$isFeatured
      ? `border:2px solid ${tokens.color.brand[600]};
        margin-top: 23px;`
      : `border: 1px solid ${tokens.color.border.card.default};`}
`;

export const HenrySuggestionChip = styled.div`
  position: absolute;
  left: 21px;
  top: 0;
  transform: translateY(-50%);
  background: ${tokens.color.brand[600]};
  border-radius: 32px;
  color: white;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 7px 12px;
`;

export const HenrySuggestionIRATileLogoDiv = styled.div`
  padding-top: 23px;
  padding-left: 12px;
  img {
    max-width: 100%;
    max-height: 30px;
    object-fit: contain;
  }
`;

export const HenrySuggestionIRATileLogoDivider = styled.div`
  background: ${tokens.color.neutral[500]};
  height: 1px;
  width: 100%;
  content: "";
`;

export const HenrySuggestionFeatureDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const FeatureChip = styled.div`
  padding: 4px 12px;
  background: ${tokens.color.brand[50]};
  border-radius: 24px;
`;

export const HereIsWhyHeaderAccordion = styled.div``;

export const HereIsWhyHeader = styled.button`
  display: flex;
  gap: 10px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  color: ${tokens.color.brand[600]};
  cursor: pointer;
`;

export const HereIsWhyContent = styled.div<{ $isExpanded: boolean }>`
  transition: height 1s ease-in-out;
  ${(props) =>
    props.$isExpanded
      ? `
      height:auto;
  padding-top: 16px;
  display:flex;
  flex-direction:column;
  gap: 16px;`
      : `
  overflow:hidden;
  height:0;
  padding:0;`}
`;

export const HereIsWhyItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const HenrySuggestionCTADiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
  gap: 8px;

  .mds-button {
    width: 100%;
  }
`;

export const SeeMoreOptionsButton = styled.button`
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  gap: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.color.text.secondary};
`;

export const SeeMoreOptionsContent = styled.div<{ $show: boolean }>`
  transition: height 1s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${(props) =>
    props.$show
      ? `
      height:auto;
  padding-top: 40px;
  display:flex;
  flex-direction:column;
  gap: 16px;`
      : `
  overflow:hidden;
  height:0;
  padding:0;`};
`;

export const DisclimaerText = styled(LabelMedium)`
  color: ${tokens.color.text.tertiary};
  margin-top: 40px;
  display: flex;
`;

export const IRAPartnerMainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 32px;
`;

export const IRAPartnerContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Item = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const ItemDot = styled.div`
  display: flex;
  align-items: center;
  height: 18px;
  width: 5px;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
